import { render } from "./WordBank.vue?vue&type=template&id=6315f3d7&scoped=true"
import script from "./WordBank.vue?vue&type=script&lang=js"
export * from "./WordBank.vue?vue&type=script&lang=js"

import "./WordBank.vue?vue&type=style&index=0&id=6315f3d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6315f3d7"]])

export default __exports__